import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
// import { ChakraProvider } from '@chakra-ui/react';
import { AuthProvider } from './contexts/AuthContext';
import { useTheme, useAnalytics, useConfig } from './hooks';
import awsconfig from './aws-exports.js';
import App from './App';
import './styles/landing-page.scss';

const AppWithProviders: React.FC = () => {
  useTheme({ visualRefresh: true });
  useAnalytics({
    sessionTracking: true,
    pageTracking: true,
    pageEventName: 'IndexPage'
  });
  useConfig({
    amplifyConfig: awsconfig,
    onConfigured: () => {
      console.log('AWS Amplify configured successfully');
    }
  });
  
  return (
      <AuthProvider>
        <Router>
          <App />
        </Router>
      </AuthProvider>
  );
};

// Kek this adds Cloudscape's 3.0 Visual Refresh to the page
document.body.className = "awsui-visual-refresh";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AppWithProviders />
  </React.StrictMode>
);
